import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Panel_Header.scss';
import { _className, ComponentSync, LL_H_C } from '@nu-art/thunderstorm-frontend/index';
import { QSearch } from '../../q-components/index.js';
export class Panel_Header extends ComponentSync {
    deriveStateFromProps(nextProps) {
        return { title: nextProps.title };
    }
    render() {
        return _jsxs(LL_H_C, { className: _className('default_panel_header', this.props.headerClassName), children: [this.state.title &&
                    _jsx("div", { className: _className('unselectable', 'header__title', this.state.title.className), children: this.state.title.label }), _jsx(QSearch, { id: this.props.qsearchId, filter: this.props.config?.filter, onSearch: (filter) => {
                        this.props.onFilterChanged(filter);
                        this.props.onConfigChanged?.();
                    } }), !!this.props.headerTail && this.props.headerTail] });
    }
}
//# sourceMappingURL=Panel_Header.js.map